import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "De volgende tags zijn tijdens deze keuring toegevoegd.", -1)

import { computed } from 'vue'
import { surveyStore } from '@/stores/survey'
import MediaItem from '@/types/mediaItem'
import Filelist from '@/components/Filelist.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyIssueTagOverviewCard',
  setup(__props) {

const surveyHasTags = computed(() => {
  if (!surveyStore().survey.building) {
    return []
  }

  const media = surveyStore().survey.building.media
  const directories = Object.keys(media)

  const hasTagsForSurvey = (directory:string) => {
    return media[directory] && media[directory].tags?.some((tag:{ surveyId:number }) => tag.surveyId === surveyStore().survey.id)
  }

  return directories.filter(directory => hasTagsForSurvey(directory))
})

const files = computed(() => {
  const files:MediaItem[] = []
  surveyHasTags.value.forEach((dir:string) => {
    files.push(surveyStore().survey.building.media[dir])
  })
  return files
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_unref(surveyHasTags).length)
    ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, {
                title: "Overzicht - Service tags",
                bordered: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: [16,16] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(Filelist, {
                            media: _unref(files),
                            filter: { key: 'surveyId', value: _unref(surveyStore)().survey.id }
                          }, null, 8, ["media", "filter"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})